export enum RenterPolicyCycleResult {
    INACTIVE_PERIOD = "INACTIVE_PERIOD",
    INACTIVE_PERIOD_WITH_INSURANCE = "INACTIVE_PERIOD_WITH_INSURANCE"
}
